module.exports = __webpack_public_path__ + "img/print.7ea5002d.svg";